import { render, staticRenderFns } from "./ThirdPartyInsuranceForm.vue?vue&type=template&id=acc36e48"
import script from "./ThirdPartyInsuranceForm.vue?vue&type=script&lang=js"
export * from "./ThirdPartyInsuranceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports